/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import { Outlet } from 'react-router-dom';

class ContentRouter extends React.Component {

	render() {
		let { children, ...otherProps} = this.props;

		return (
			<Outlet context={otherProps}/>
		);

	}
}

ContentRouter.propTypes = {
	routeViewType: PropTypes.number,
	getSavedPath: PropTypes.func,
	recordPath: PropTypes.func,
};

ContentRouter.defaultProps = {
	routeViewType: 0, // ROUTE_VIEW_ADVANCED
	getSavedPath: null,
	recordPath: null,
};

export default ComponentWithContext(ContentRouter);
